@if (loader.isLoading()) {
  <div class="loading-overlay" aria-live="polite" aria-busy="true" role="status">
    <div class="overlay-content">
      <div class="spinner" aria-hidden="true"></div>
      <p class="loading-text">Loading…</p>
    </div>
  </div>
}
